import { ProjectPlanNew } from '../../view/pages/ProjectPlanNew'
import { Cockpit } from '../../lib/commons/appFunction'
import { intl } from '../../i18n'
import { useRegisterDemoFunctionLayer } from './useRegisterDemoFunctionLayer'
import { useDisableExternalNavigation } from './useDisableExternalNavigation'
import { GanttDisplayUnit } from '../../domain/value-object/GanttParameterVO'
import { GANTT_ONLY_MOCK_FUNCTION_UUID } from '../data/ui-states/gantt'
import { useOverrideDemoGanttParameter } from './useOverrideDemoGanttParameter'
import { DEMO_PLAN_START_DAY } from '../data/projects/wbs-items'
import { dayOffsetToDate } from '../data/shared'
import { DemoSupportSiteGuide } from './DemoSupportSiteGuide'

// ガントチャートとタスク名列のみを表示する専用モック画面。
// 本番の機能マスタ・ルーティング定義とは独立した固定ルート
// （DemoRoutes.tsx）からのみ到達する。画面自体は通常のProjectPlanNewと同一で、
// 列の絞り込みはfunctionUuidに紐づくUIStateで行う。
const MOCK_FUNCTION_UUID = GANTT_ONLY_MOCK_FUNCTION_UUID
const EXTERNAL_ID = 'mock.projectPlan.gantt'

// ガントの左端をWBSルート行の予定開始日（＝最も早い工程の開始日）に合わせる。
// 今日からの相対で決めると、WBSの先頭が画面外になったり手前が空いたりして
// ブレるため、WBSと同じ日付軸（dayOffsetToDate）から直接算出する。
// 右端は開始日から14ヶ月後。WBSの計画全体（約14.3ヶ月）の
// 末尾が数日はみ出すが、デモの見え方としては許容する。
const GANTT_START_DATE = dayOffsetToDate(DEMO_PLAN_START_DAY)
const GANTT_MONTHS_TO_DISPLAY = 14

// ProjectPlan.tsxと同じ理由でルート期間への自動追従を切る。ここは月単位指定の
// ため単位自体は変わらないが、有効だと期間もルート期間に合わせて張り替えられ、
// 指定した14ヶ月が失われる。
const GANTT_DISPLAY_OPTIONS = { fitToRootPeriod: false }

export const ProjectPlanGantt = () => {
  useRegisterDemoFunctionLayer(
    EXTERNAL_ID,
    intl.formatMessage({ id: 'demo.title.gantt' })
  )
  useDisableExternalNavigation()
  // 14ヶ月分を表示するためガント列の内容幅が広い。列幅の最適化は製品側で常時
  // 適用されるが、内容幅の50%が下限のため、表示領域が狭いと横スクロールは残る
  // （ganttUtil.tsのGANTT_FIT_MIN_CONTENT_RATIO）。
  useOverrideDemoGanttParameter(
    GanttDisplayUnit.MONTH,
    GANTT_START_DATE,
    GANTT_MONTHS_TO_DISPLAY,
    GANTT_DISPLAY_OPTIONS
  )
  return (
    <>
      <DemoSupportSiteGuide page="projectPlanGantt" />
      <ProjectPlanNew
        key={MOCK_FUNCTION_UUID}
        externalId={EXTERNAL_ID}
        uuid={MOCK_FUNCTION_UUID}
        class={ProjectPlanNew}
        cockpit={Cockpit.Project}
        defaultPath="/gantt/demo"
        tags={[]}
      />
    </>
  )
}
